const parseDate = (string) => Math.floor(Date.parse(string));

// noinspection JSUnusedGlobalSymbols
export default parseDate;
